define("powergen/models/keyboard",
  [],
  function() {
    "use strict";
    var Keyboard;

    Keyboard = DS.Model.extend({
      rows: DS.hasMany('keyboardRow')
    });


    return Keyboard;
  });